export const INBOX_GENERIC_ACTIVITY_LIST_SORT = 'INBOX_GENERIC_ACTIVITY_LIST_SORT';

export const INBOX_LIST_GENERIC_ACTIVITY_LIST_VIEW_MODE_LARGE = 'INBOX_LIST_GENERIC_ACTIVITY_LIST_VIEW_MODE_LARGE';
